import $ from 'jquery'

$(document).ready(function() {
  co_stellenausschreibungen()
})

function co_stellenausschreibungen() {
  $('.co_stellenausschreibungen').each(function() {})
}
